$shm_hitalama_entergate_internal $shm_hitalama_entergate
	pending_login? \
	Form $shm_hitalama_entergate_internal_form
		pending_login? <=> pending_login? \

$shm_hitalama_entergate_internal_form $shm_hitalama_entergate_form
	pending_login? \
	sub /
		<= Title
		<= Login_label
		<= Actions
		<= Message
	Title $mol_view
		sub / \Регистрация
